<!-- внешние страницы работы с операциями  -->
<template>
	<!-- просмотр операции для неавторизованных пользователей -->
	<div v-if="!$store.state.is_auth && $route.path.indexOf('/operation/view/') === 0">
		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				<span @click="localErrorMessage = ''" class="close" aria-label="close" :title="'main/close' | ftc">×</span>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
			</div>
		</transition>
		<!-- ===================================== -->

		<!-- Заголовок -->
		<h4 class="w5-view-header">{{ viewData.title | ftc }}</h4>
		<!-- ===================================== -->

		<!-- поля -->
		<div v-if="Keys.length" v-for="row in Keys" :key="row" class="w5-form-row">
			<viewComponent
				v-for="(field, idx) in sortDATA[row]" :key="row + '_' + idx"
				:data="viewData"
				:rowCount="sortDATA[row].length"
				:y="row"
				:x="idx"
				:field="field"
				crud="operation"
				realCrudName="operation"
				:firstElement="sortDATA && sortDATA['1'] && sortDATA['1'][0] ? sortDATA['1'][0] : null"
			/>
		</div>
		<!-- ===================================== -->
	</div>
	<crudView v-else />
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import crudView from '@/components/crud/View'
import viewComponent from '@/components/elements/view'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование компонента
	//=========================================================================
	name: 'operationView',
	//=========================================================================
	// локальные данные компонента
	//=========================================================================
	data() {
		return {
			// ID наблюдаемого объекта
			id: null,

			// локальное сообщение об ошибке
			localErrorMessage: '',

			// отсортированные данные
			sortDATA: {},

			// ключи полей
			Keys: false,

			// кешированные данные для просмотра
			viewData: {},

			// таймер и его счетчик
			timerRefresh: null,
			timerCounter: 0
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// обнулим таймер
		this.timerRefresh = null
		this.timerCounter = 0

		// инициализация начальных данных по URL
		this.initData(this.$route.path)

		// теперь можно запросить данные
		this.requestViewData()
	},
	//=========================================================================
	// перед уничтожением компонента - чистим за собой
	//=========================================================================
	beforeDestroy() {
		if (this.timerRefresh)
		{
			clearTimeout(this.timerRefresh)
			this.timerCounter = 0
		}
	},
	//=========================================================================
	// наблюдаем переходы между CRUD внутри одного и того же компонента
	//=========================================================================
	watch: {
		'$route': function(to, from) {
			// инициируем основные данные, в частности и this.crud
			this.initData(to.path)

			// теперь можно запросить данные
			this.requestViewData()
		}
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// какие поля можно показывать
		//---------------------------------------------------------------------
		canShow(fieldName) {
			return ['operation_status', 'operation_summa', 'payment', 'operation_created', 'operation_updated'].indexOf(fieldName) > -1
		},
		//---------------------------------------------------------------------
		// инициализация начальных данных
		//---------------------------------------------------------------------
		initData(path) {
			// обнуляем основные значения
			this.id = null
			this.sortDATA = {}
			this.Keys = false
			this.localErrorMessage = ''

			// парсим входящий URL
			let _urlParts = path
				.substr(path.charAt(0) === '/' ? 1 : 0)
				.split('/')
			// должно быть ровно три части
			if (_urlParts.length !== 3 ||
				!_urlParts[0] || !_urlParts[0].length || _urlParts[0] !== 'operation' ||
				!_urlParts[1] || !_urlParts[1].length || _urlParts[1] !== 'view' ||
				!_urlParts[2] || !_urlParts[2].length)
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// получим ID объекта
			this.id = _urlParts[2]
		},
		//---------------------------------------------------------------------
		// запрос данных для просмотра
		//---------------------------------------------------------------------
		requestViewData(isSilence) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверка: остановим таймер и счетчик
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.timerRefresh)
				clearTimeout(this.timerRefresh)

			// если не нужно показывать лоадер
			if (isSilence === true) this.$store.commit('needShowLoader', false)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// готовим URL
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _url = '/operation/view/' + this.id

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// производим запрос
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.forms_Get(_url, false,
				// успешно получили данные
				(data) => {
					// включаем лоадер обратно
					this.$store.commit('needShowLoader', true)

					// проверим данные
					if (!data || data['status'] !== 'ok' || !data['operation'])
					{
						// ошибка - некорректные данные
						this.form_ErrorMessage = this.localeFtc('error/api_incorrect')
					}
					else
					{
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// данные пришли - корректные
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// сортировка
						this.sortDATA = this._order()
						// ключи полей
						this.Keys = Object.keys(this.sortDATA).sort(function(a, b) {
							return a - b
						})
						// свежие данные полей
						this.viewData = this.form_GetData
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// если мы во внешней форме - нужно запустить таймер?
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						if (!this.$store.state.is_auth && this.$route.path.indexOf('/operation/view/') === 0 && /^[a-z0-9]+$/.test(this.id) && this.id.length > 12)
						{
							// какой статус
							let _status = -1
							if (this.viewData && typeof this.viewData === 'object' && 'operation' in this.viewData &&
								this.viewData['operation'] && 'operation_status' in this.viewData['operation'] &&
								this.viewData['operation']['operation_status'] && 'value' in this.viewData['operation']['operation_status'])
								_status = this.viewData['operation']['operation_status']['value']

							// если статус неопределен или неоплачено, только тогда запускаем таймер
							if (_status <= 0)
								this.timerRefresh = setTimeout(this.timerFunction, 10000)
						}
					}
				},
				() => this.$store.commit('needShowLoader', true)
			)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// функция таймера
		//---------------------------------------------------------------------
		timerFunction() {
			// считаем период
			this.timerCounter++
			// если прошло 3 минуты - больше ничего не делаем
			if (this.timerCounter >= 18) return
			// иначе - делаем рефреш данных
			this.requestViewData(true)
		},
		//---------------------------------------------------------------------
		// сортирует данные согласно порядку
		//---------------------------------------------------------------------
		_order() {
			let obj
			let __obj
			let ____obj
			let tmp
			let order
			let isLink = 0
			let nm = ''
			let sortDATA = {}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// бежим по всем данным
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			for (let idx in this.form_GetData) if (this.form_GetData.hasOwnProperty(idx))
			{
				// поля, которые пропускаем
				if (idx === 'logs') continue

				// текущий объект
				obj = this.form_GetData[idx]

				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				// рассматриваем только объекты
				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
				if (obj && typeof obj === 'object')
				{
					// если уже есть порядок
					if ('order' in obj && obj['type'] !== 'hidden' && this.canShow(idx))
					{
						// получим индекс
						tmp = parseInt(obj['order'])
						order = isNaN(tmp) ? 0 : tmp

						// запомним его
						if (!sortDATA[order])
						{
							sortDATA[order] = []
							sortDATA[order].push(idx)
						}
						else sortDATA[order].push(idx)
					}
					// порядка еще нет - опускаемся на уровень ниже
					else
					{
						// это ссылка?
						isLink = 0
						nm = ''

						for (let i in obj) if (obj.hasOwnProperty(i))
							if (/_name$/i.test(i) || /_id$/i.test(i) || /_login$/i.test(i))
							{
								nm = i.match(/(.*?)_name$/)
								if (nm === null)
								{
									nm = i.match(/(.*?)_id$/)
									if (nm === null)
									{
										nm = i.match(/(.*?)_login$/)
										if (nm == null)
										{
											if (this.$store.state.isDebug) window.DEBUG.error('не найдено поле')
										}
										else nm = nm[1]
									}
									else nm = nm[1]
								}
								else nm = nm[1]

								isLink++
							}

						// если встретили два поля - значит ссылка
						if (isLink === 2 && idx !== this.realCrudName) isLink = true
						else isLink = false

						// если это ссылка
						if (isLink)
						{
							// получим индекс
							tmp = parseInt(obj[nm + '_id']['order'])
							order = isNaN(tmp) ? 0 : tmp

							// запомним его
							if (!sortDATA[order])
							{
								sortDATA[order] = []
								sortDATA[order].push(idx)
							}
							else sortDATA[order].push(idx)
						}
						// это не ссылка - просто собираем все объекты
						else
						{
							for (let i in obj) if (obj.hasOwnProperty(i))
							{
								if (!this.canShow(i)) continue
								// текущий объект
								__obj = obj[i]

								// рассматриваем только объекты
								if (__obj && typeof __obj === 'object' &&
									'order' in __obj &&
									'title' in __obj &&
									'value' in __obj && __obj['value'] !== null && __obj['value'] !== undefined &&
									'type' in __obj && __obj['type'] !== 'hidden')
								{
									// получим индекс
									tmp = parseInt(__obj['order'])
									order = isNaN(tmp) ? 0 : tmp

									// запомним его
									if (!sortDATA[order])
									{
										sortDATA[order] = []
										sortDATA[order].push(i)
									}
									else sortDATA[order].push(i)
								}
								else
								{
									// права для ролей
									if (idx === 'role' && i === 'permissions') sortDATA[9999] = [i]
									// данные услуги в поле service_data
									else if (idx === 'service' && i === 'service_data')
									{
										// получим индекс
										tmp = parseInt(__obj['order'])
										order = isNaN(tmp) ? 0 : tmp

										// запомним его
										if (!sortDATA[order])
										{
											sortDATA[order] = []
											sortDATA[order].push(i)
										}
										else sortDATA[order].push(i)
									}
									// это объект, содержащий еще объекты
									else
									{
										// пробежимся по всем свойствам
										for (let w in __obj) if (__obj.hasOwnProperty(w))
										{
											// текущий объект
											____obj = __obj[w]

											// рассматриваем только объекты
											if (____obj && typeof ____obj === 'object' &&
												'order' in ____obj &&
												'title' in ____obj &&
												'value' in ____obj && ____obj['value'] !== null && ____obj['value'] !== undefined &&
												'type' in ____obj && ____obj['type'] !== 'hidden')
											{
												// получим индекс
												tmp = parseInt(____obj['order'])
												order = isNaN(tmp) ? 0 : tmp

												// запомним его
												if (!sortDATA[order])
												{
													sortDATA[order] = []
													sortDATA[order].push(w)
												}
												else sortDATA[order].push(w)
											}
										}
									}
								}
							}
						}
					}
				}

				//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// возвращаем результат
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			return sortDATA
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		crudView,
		viewComponent
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// operationView.vue?c91ab9d0